import { render } from "./Details.vue?vue&type=template&id=229f9280&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=229f9280&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229f9280"]])

export default __exports__